"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.QuoteTXBJTable = void 0;
var react_1 = __importStar(require("react"));
require("./index.less");
var qtpager_1 = require("../qtpager");
var config_1 = require("../../modules/quote/config");
var quote_1 = require("../../modules/quote");
var tablepage_config_1 = require("./tablepage_config");
var react_router_dom_1 = require("react-router-dom");
var lodash_1 = require("lodash");
var url_1 = require("../../modules/url");
/**
 * 行情-期权-t型报价表格
 * @returns
 */
function QuoteTXBJTable(props) {
    // console.info(props.time)
    var _a;
    var _b = (0, react_1.useState)([]), showdata = _b[0], SetShowData = _b[1];
    var location = (0, react_router_dom_1.useLocation)();
    var hash = location.hash.toLowerCase();
    if (hash.substring(0, 1) == '#') {
        hash = hash.substring(1);
    }
    var thishash = (0, react_1.useRef)(hash);
    //配置字段
    var hashtable_item = tablepage_config_1.hashtable[hash];
    var tableitem = (0, lodash_1.cloneDeep)(tablepage_config_1.tableitemconfig[hashtable_item.table]);
    var mt = (_a = props.mt) !== null && _a !== void 0 ? _a : 0;
    // let default_sort = getDefaultSort(tableitem) //默认排序  
    var default_sort = getDefaultSort(tableitem); //默认排序  
    var url_sort_direct = (0, url_1.getQueryParams)("sr");
    var sort_direct = url_sort_direct != null ? url_sort_direct : default_sort.sort_direct; // 优先url
    var _c = (0, react_1.useState)(0), count = _c[0], SetCount = _c[1];
    var _d = (0, react_1.useState)(1), nowindex = _d[0], SetNowIndex = _d[1];
    var _e = (0, react_1.useState)(default_sort.sort), sortitem = _e[0], SetSortItem = _e[1];
    var _f = (0, react_1.useState)(sort_direct), sortdirect = _f[0], SetSortDirect = _f[1]; // 优先url
    var _g = (0, react_1.useState)(Math.random()), data_reload = _g[0], setReload = _g[1];
    var pagesize = 20;
    var getData = function () {
        return __awaiter(this, void 0, void 0, function () {
            var secid, quotedata;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        secid = hashtable_item.fs;
                        return [4 /*yield*/, (0, quote_1.searchListQuoteQiQuanWithPage)(secid, props.time, tableitem.filter(function (v) { return v.type == 'quote'; }).map(function (v) { return config_1.QuoteItem[v.value]; }), sortitem, nowindex, pagesize, sortdirect)];
                    case 1:
                        quotedata = _a.sent();
                        if (quotedata.result.length > 0)
                            SetShowData(quotedata.result);
                        SetCount(quotedata.count);
                        return [2 /*return*/];
                }
            });
        });
    };
    (0, react_1.useEffect)(function () {
        if (hash != thishash.current) {
            SetNowIndex(1);
            SetSortItem(default_sort.sort);
            SetSortDirect(default_sort.sort_direct);
            setReload(Math.random());
        }
        thishash.current = hash;
    }, [hash]);
    (0, react_1.useEffect)(function () {
        SetNowIndex(1);
        getData();
    }, [sortdirect, sortitem, props.time, data_reload]);
    (0, react_1.useEffect)(function () {
        SetNowIndex(1);
        SetSortItem(default_sort.sort);
        SetSortDirect(default_sort.sort_direct);
        getData();
    }, [props.time]);
    (0, react_1.useEffect)(function () {
        getData();
    }, [nowindex]);
    var changeSort = function (tosortitem) {
        var _a;
        SetSortItem(tosortitem);
        if (sortitem == tosortitem) {
            if (sortdirect == 0) {
                SetSortDirect(1);
            }
            else {
                SetSortDirect(0);
            }
        }
        else {
            SetSortDirect((_a = props.first_sort_dir) !== null && _a !== void 0 ? _a : 1);
        }
    };
    var refresh = function () {
        getData();
    };
    return (react_1.default.createElement("div", { className: "quotetable_txbj", style: mt > 0 ? { marginTop: mt } : {} },
        react_1.default.createElement("table", null,
            react_1.default.createElement("thead", null,
                react_1.default.createElement("tr", null, tableitem.filter(function (v) { return v.hide != true; }).map(function (v, index) {
                    return react_1.default.createElement("th", { key: index, className: v.sort ? 'sort' : '', title: v.sort ? '点击排序' : '', onClick: function () { if (v.sort) {
                            changeSort(config_1.ListItemConfig === null || config_1.ListItemConfig === void 0 ? void 0 : config_1.ListItemConfig[config_1.QuoteItem[v.value]].sort);
                        } } },
                        v.title,
                        v.tip && react_1.default.createElement("span", { dangerouslySetInnerHTML: { __html: v.tip } }),
                        v.sort && (config_1.ListItemConfig === null || config_1.ListItemConfig === void 0 ? void 0 : config_1.ListItemConfig[config_1.QuoteItem[v.value]].sort) == sortitem && sortdirect == 1 &&
                            react_1.default.createElement("span", { className: "icon_down" }),
                        v.sort && (config_1.ListItemConfig === null || config_1.ListItemConfig === void 0 ? void 0 : config_1.ListItemConfig[config_1.QuoteItem[v.value]].sort) == sortitem && sortdirect == 0 &&
                            react_1.default.createElement("span", { className: "icon_up" }));
                }))),
            react_1.default.createElement("tbody", null, showdata.map(function (v, index) {
                return react_1.default.createElement("tr", { key: index }, tableitem.filter(function (v) { return v.hide != true; }).map(function (v2, index2) {
                    var bg_color = getBJDiff(index2, v[config_1.QuoteItem.期权T型报价行权价].txt, v[config_1.QuoteItem.期权标的券最新价].txt);
                    return (react_1.default.createElement("td", { key: index2, className: v2.tdclass ? "".concat(v2.tdclass, " ").concat(bg_color) : "".concat(bg_color) },
                        v2.type == 'index' && ((nowindex - 1) * pagesize + index + 1),
                        v2.type == 'quote' && v[config_1.QuoteItem[v2.value]] && v[config_1.QuoteItem[v2.value]].html));
                }));
            }))),
        count > 0 &&
            react_1.default.createElement(qtpager_1.QTPager, { count: count, pagesize: pagesize, nowindex: nowindex, onChangePager: function (toindex) { SetNowIndex(toindex); } })));
}
exports.QuoteTXBJTable = QuoteTXBJTable;
/**
 * 获取默认的排序设置
 * @param config
 * @returns
 */
function getDefaultSort(config) {
    var finddefault = config.find(function (v) { return v.sort_default; });
    if (finddefault) {
        return {
            sort: config_1.ListItemConfig[config_1.QuoteItem[finddefault.value]].sort,
            sort_direct: finddefault.sort_direct
        };
    }
    return {
        sort: '',
        sort_direct: 1
    };
}
/**
 * 获取比价背景色
 */
function getBJDiff(index, f161, f334) {
    var diff = !!f334 ? parseFloat(f161) - parseFloat(f334) : parseFloat(f161);
    if (index < 8) {
        return !!diff ? (diff == 0 ? '' : diff < 0 ? "bj_bg_red" : "bj_bg_green") : '';
    }
    return !!diff ? (diff == 0 ? '' : diff > 0 ? "bj_bg_red" : "bj_bg_green") : '';
}
